import { useLocale } from "@/i18n/LocaleProvider";
import { countries } from "@/countries";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./select";
import { MapPin } from "lucide-react";

const CountriesSelect = ({
  setPromptCountry,
  promptCountry,
  isFull = false,
  isIcon = true,
}: any) => {
  const { t } = useLocale();
  return (
    <Select
      onValueChange={(value) => {
        let valueCurrent = value !== "" && value !== promptCountry;
        setPromptCountry(valueCurrent ? value : promptCountry);
      }}
      value={promptCountry}
    >
      <SelectTrigger className={`${isFull ? "w-full" : ""} `}>
        <div className="flex items-center gap-1">
          {isIcon && <MapPin></MapPin>}
          <SelectValue placeholder={t("legacy.select.location.1w3oek0")} />
        </div>
      </SelectTrigger>
      <SelectContent>
        {countries.map((country) => (
          <SelectItem key={country.code} value={country.code}>
            <div className="flex items-center justify-between">
              <div className="mr-2">{country.icon}</div>
              <span>{country.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CountriesSelect;
